var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<div (result)></div>\n<input (search) type=\"text\" placeholder=\"search\">\n"}],
    template = twig({"id":"$resolved:187974e6685125eeed932aac3463a6af621e087ae19130a4582cbb4eaf5d14b41b8dfb3dabdbc76479388d74bda4f50bf640e45c985af44c165739bb64b05617:magic-input-helper-search.twig","data":[{"type":"raw","value":"<div (result)></div>\n<input (search) type=\"text\" placeholder=\"search\">\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;